// Backend stores `category` and `subCategory` as single-string keys (e.g. `men`, `shirt`).
// This file keeps it simple: key -> language label.

export const CATEGORY_I18N = {
    men: { en: 'Men', tr: 'Erkek', fa: 'مرد', ps: 'نارینه', ru: 'Мужское', el: 'Ανδρικά', ar: 'رجالي' },
    women: { en: 'Women', tr: 'Kadın', fa: 'زن', ps: 'ښځینه', ru: 'Женское', el: 'Γυναικεία', ar: 'نسائي' },
    footwear: { en: 'Footwear', tr: 'Ayakkabı', fa: 'کفش', ps: 'بوټان', ru: 'Обувь', el: 'Υποδήματα', ar: 'أحذية' },
    accessory: { en: 'Accessory', tr: 'Aksesuar', fa: 'لوازم جانبی', ps: 'لوازم', ru: 'Аксессуар', el: 'Αξεσουάρ', ar: 'إكسسوار' },
    perfume: { en: 'Perfume', tr: 'Parfüm', fa: 'عطر', ps: 'عطر', ru: 'Парфюм', el: 'Άρωμα', ar: 'عطر' },
    watch: { en: 'Watch', tr: 'Saat', fa: 'ساعت', ps: 'ساعت', ru: 'Часы', el: 'Ρολόι', ar: 'ساعة' },
    sport: { en: 'Sport', tr: 'Spor', fa: 'ورزش', ps: 'ورزش', ru: 'Спорт', el: 'Αθλητικά', ar: 'رياضة' },
    others: { en: 'Others', tr: 'Diğer', fa: 'سایر', ps: 'نور', ru: 'Другое', el: 'Άλλα', ar: 'أخرى' },
    kids: { en: 'Kids', tr: 'Çocuklar', fa: 'کودکان', ps: 'ماشومان', ru: 'Детское', el: 'Παιδικά', ar: 'أطفال' },
    unisex: { en: 'Unisex', tr: 'Unisex', fa: 'یونیسکس', ps: 'یونیسکس', ru: 'Унисекс', el: 'Unisex', ar: 'للجنسين' },
    accessories: { en: 'Accessories', tr: 'Aksesuarlar', fa: 'اکسسوری‌ها', ps: 'لوازم', ru: 'Аксессуары', el: 'Αξεσουάρ', ar: 'إكسسوارات' },
};

export const SUBCATEGORY_I18N = {
    men: {
        shirt: { en: 'Shirt', tr: 'Gömlek', fa: 'پیراهن', ps: 'کمیس', ru: 'Рубашка', el: 'Πουκάμισο', ar: 'قميص' },
        blouse: { en: 'Blouse', tr: 'Bluz', fa: 'بلوز', ps: 'بلوز', ru: 'Блузка', el: 'Μπλούζα', ar: 'بلوزة' },
        pant: { en: 'Pant', tr: 'Pantolon', fa: 'شلوار', ps: 'پتلون', ru: 'Брюки', el: 'Παντελόνι', ar: 'بنطلون' },
        tie: { en: 'Tie', tr: 'Kravats', fa: 'کراوات', ps: 'ټای', ru: 'Галстук', el: 'Γραβάτα', ar: 'ربطة عنق' },
        suit: { en: 'Suit', tr: 'Takım Elbise', fa: 'کت و شلوار', ps: 'سوټ', ru: 'Костюм', el: 'Κοστούμι', ar: 'بدلة' },
        jacket: { en: 'Jacket', tr: 'Ceket', fa: 'ژاکت', ps: 'جاکټ', ru: 'Куртка', el: 'Μπουφάν', ar: 'سترة' },
        shirts: { en: 'Shirts', tr: 'Gömlekler', fa: 'پیراهن‌ها', ps: 'کمیسونه', ru: 'Рубашки', el: 'Πουκάμισα', ar: 'قمصان' },
        pants: { en: 'Pants', tr: 'Pantolonlar', fa: 'شلوارها', ps: 'پتلونونه', ru: 'Брюки', el: 'Παντελόνια', ar: 'بناطيل' },
        jackets: { en: 'Jackets', tr: 'Ceketler', fa: 'ژاکت‌ها', ps: 'جاکټونه', ru: 'Куртки', el: 'Μπουφάν', ar: 'سترات' },
        shoes: { en: 'Shoes', tr: 'Ayakkabılar', fa: 'کفش‌ها', ps: 'بوټان', ru: 'Обувь', el: 'Παπούτσια', ar: 'أحذية' },
        suits: { en: 'Suits', tr: 'Takımlar', fa: 'کت‌وشلوارها', ps: 'سوټونه', ru: 'Костюмы', el: 'Κοστούμια', ar: 'بدلات' },
        casual: { en: 'Casual', tr: 'Günlük', fa: 'روزمره', ps: 'ورځنی', ru: 'Повседневное', el: 'Casual', ar: 'كاجوال' },
        sportswear: { en: 'Sportswear', tr: 'Spor Giyim', fa: 'پوشاک ورزشی', ps: 'ورزشي جامې', ru: 'Спортивная одежда', el: 'Αθλητικά ρούχα', ar: 'ملابس رياضية' },
    },
    women: {
        shirt: { en: 'Shirt', tr: 'Gömlek', fa: 'پیراهن', ps: 'کمیس', ru: 'Рубашка', el: 'Πουκάμισο', ar: 'قميص' },
        blouse: { en: 'Blouse', tr: 'Bluz', fa: 'بلوز', ps: 'بلوز', ru: 'Блузка', el: 'Μπλούζα', ar: 'بلوزة' },
        pant: { en: 'Pant', tr: 'Pantolon', fa: 'شلوار', ps: 'پتلون', ru: 'Брюки', el: 'Παντελόνι', ar: 'بنطلون' },
        dress: { en: 'Dress', tr: 'Elbise', fa: 'لباس', ps: 'جامې', ru: 'Платье', el: 'Φόρεμα', ar: 'فستان' },
        skirt: { en: 'Skirt', tr: 'Etek', fa: 'دامن', ps: 'دامن', ru: 'Юбка', el: 'Φούστα', ar: 'تنورة' },
        jacket: { en: 'Jacket', tr: 'Ceket', fa: 'ژاکت', ps: 'جاکټ', ru: 'Куртка', el: 'Μπουφάν', ar: 'سترة' },
        scarf: { en: 'Scarf', tr: 'Eşarp', fa: 'روسری', ps: 'ټیکری', ru: 'Шарф', el: 'Κασκόλ', ar: 'وشاح' },
        tops: { en: 'Tops', tr: 'Üst', fa: 'تاپ', ps: 'پورتنۍ جامې', ru: 'Топы', el: 'Τοπ', ar: 'توبات' },
        pants: { en: 'Pants', tr: 'Pantolonlar', fa: 'شلوارها', ps: 'پتلونونه', ru: 'Брюки', el: 'Παντελόνια', ar: 'بناطيل' },
        shoes: { en: 'Shoes', tr: 'Ayakkabılar', fa: 'کفش‌ها', ps: 'بوټان', ru: 'Обувь', el: 'Παπούτσια', ar: 'أحذية' },
        bags: { en: 'Bags', tr: 'Çantalar', fa: 'کیف‌ها', ps: 'کڅوړې', ru: 'Сумки', el: 'Τσάντες', ar: 'حقائب' },
        accessories: { en: 'Accessories', tr: 'Aksesuarlar', fa: 'اکسسوری‌ها', ps: 'لوازم', ru: 'Аксессуары', el: 'Αξεσουάρ', ar: 'إكسسوارات' },
    },
    footwear: {
        sneakers: { en: 'Sneakers', tr: 'Spor Ayakkabı', fa: 'کتانی', ps: 'سپورټ بوټان', ru: 'Кроссовки', el: 'Sneakers', ar: 'أحذية رياضية' },
        boots: { en: 'Boots', tr: 'Bot', fa: 'نیم‌بوت', ps: 'بوټ', ru: 'Ботинки', el: 'Μπότες', ar: 'أحذية طويلة' },
        sandals: { en: 'Sandals', tr: 'Sandalet', fa: 'صندل', ps: 'صندل', ru: 'Сандалии', el: 'Σανδάλια', ar: 'صندل' },
        heels: { en: 'Heels', tr: 'Topuklu', fa: 'کفش پاشنه بلند', ps: 'لوړه پاشنه', ru: 'Туфли на каблуке', el: 'Τακούνια', ar: 'كعب عالي' },
    },
    accessory: {
        belt: { en: 'Belt', tr: 'Kemer', fa: 'کمربند', ps: 'کمربند', ru: 'Ремень', el: 'Ζώνη', ar: 'حزام' },
        hat: { en: 'Hat', tr: 'Şapka', fa: 'کلاه', ps: 'ټوپی', ru: 'Шляпа', el: 'Καπέλο', ar: 'قبعة' },
        scarf: { en: 'Scarf', tr: 'Eşarp', fa: 'شال', ps: 'شال', ru: 'Шарф', el: 'Κασκόλ', ar: 'وشاح' },
        glove: { en: 'Glove', tr: 'Eldiven', fa: 'دستکش', ps: 'دستکش', ru: 'Перчатки', el: 'Γάντια', ar: 'قفازات' },
    },
    perfume: {
        men: { en: 'Men Perfume', tr: 'Erkek Parfüm', fa: 'عطر مردانه', ps: 'نارینه عطر', ru: 'Мужской парфюм', el: 'Ανδρικό άρωμα', ar: 'عطر رجالي' },
        women: { en: 'Women Perfume', tr: 'Kadın Parfüm', fa: 'عطر زنانه', ps: 'ښځینه عطر', ru: 'Женский парфюм', el: 'Γυναικείο άρωμα', ar: 'عطر نسائي' },
        unisex: { en: 'Unisex Perfume', tr: 'Unisex Parfüm', fa: 'عطر یونیسکس', ps: 'یونیسکس عطر', ru: 'Унисекс парфюм', el: 'Unisex άρωμα', ar: 'عطر للجنسين' },
    },
    watch: {
        analog: { en: 'Analog', tr: 'Analog', fa: 'آنالوگ', ps: 'انلاګ', ru: 'Аналоговые', el: 'Αναλογικό', ar: 'تناظرية' },
        digital: { en: 'Digital', tr: 'Dijital', fa: 'دیجیتال', ps: 'ډیجیټل', ru: 'Цифровые', el: 'Ψηφιακό', ar: 'رقمية' },
        smart: { en: 'Smart', tr: 'Akıllı', fa: 'هوشمند', ps: 'سمارټ', ru: 'Умные', el: 'Έξυπνο', ar: 'ذكية' },
    },
    sport: {
        equipment: { en: 'Equipment', tr: 'Ekipman', fa: 'تجهیزات', ps: 'تجهیزات', ru: 'Снаряжение', el: 'Εξοπλισμός', ar: 'معدات' },
        clothing: { en: 'Clothing', tr: 'Giyim', fa: 'پوشاک', ps: 'جامې', ru: 'Одежда', el: 'Ρούχα', ar: 'ملابس' },
        footwear: { en: 'Footwear', tr: 'Spor Ayakkabı', fa: 'کفش ورزشی', ps: 'ورزشي بوټان', ru: 'Спортивная обувь', el: 'Αθλητικά παπούτσια', ar: 'أحذية رياضية' },
    },
    others: {
        general: { en: 'General', tr: 'Genel', fa: 'عمومی', ps: 'عمومي', ru: 'Общее', el: 'Γενικά', ar: 'عام' },
        misc: { en: 'Misc', tr: 'Çeşitli', fa: 'متفرقه', ps: 'متفرقه', ru: 'Разное', el: 'Διάφορα', ar: 'متنوع' },
        other: { en: 'Other', tr: 'Diğer', fa: 'سایر', ps: 'نور', ru: 'Другое', el: 'Άλλο', ar: 'أخرى' },
        miscellaneous: { en: 'Miscellaneous', tr: 'Çeşitli', fa: 'متفرقه', ps: 'متفرقه', ru: 'Разное', el: 'Διάφορα', ar: 'متنوعات' },
    },
    kids: {
        boys: { en: 'Boys', tr: 'Erkek Çocuk', fa: 'پسرانه', ps: 'هلکان', ru: 'Мальчики', el: 'Αγόρια', ar: 'أولاد' },
        girls: { en: 'Girls', tr: 'Kız Çocuk', fa: 'دخترانه', ps: 'نجونې', ru: 'Девочки', el: 'Κορίτσια', ar: 'بنات' },
        toddlers: { en: 'Toddlers', tr: 'Bebek', fa: 'نوپا', ps: 'ماشومان', ru: 'Малыши', el: 'Νήπια', ar: 'صغار' },
        shoes: { en: 'Shoes', tr: 'Çocuk Ayakkabı', fa: 'کفش بچگانه', ps: 'د ماشومانو بوټان', ru: 'Детская обувь', el: 'Παιδικά παπούτσια', ar: 'أحذية أطفال' },
        accessories: { en: 'Accessories', tr: 'Çocuk Aksesuarları', fa: 'اکسسوری بچگانه', ps: 'د ماشومانو لوازم', ru: 'Детские аксессуары', el: 'Παιδικά αξεσουάρ', ar: 'إكسسوارات أطفال' },
    },
    unisex: {
        hoodies: { en: 'Hoodies', tr: 'Kapüşonlu', fa: 'هودی', ps: 'هودي', ru: 'Худи', el: 'Φούτερ', ar: 'هودي' },
        tshirts: { en: 'T-Shirts', tr: 'Tişört', fa: 'تی‌شرت', ps: 'ټي شرټ', ru: 'Футболки', el: 'T-shirts', ar: 'تيشيرت' },
        joggers: { en: 'Joggers', tr: 'Eşofman', fa: 'جگر', ps: 'جوګر', ru: 'Джоггеры', el: 'Φόρμες', ar: 'بنطلون رياضي' },
        shoes: { en: 'Shoes', tr: 'Ayakkabı', fa: 'کفش', ps: 'بوټان', ru: 'Обувь', el: 'Παπούτσια', ar: 'أحذية' },
        hats: { en: 'Hats', tr: 'Şapka', fa: 'کلاه', ps: 'ټوپۍ', ru: 'Шапки', el: 'Καπέλα', ar: 'قبعات' },
    },
    accessories: {
        belts: { en: 'Belts', tr: 'Kemerler', fa: 'کمربندها', ps: 'کمربندونه', ru: 'Ремни', el: 'Ζώνες', ar: 'أحزمة' },
        wallets: { en: 'Wallets', tr: 'Cüzdanlar', fa: 'کیف پول', ps: 'بټوه', ru: 'Кошельки', el: 'Πορτοφόλια', ar: 'محافظ' },
        sunglasses: { en: 'Sunglasses', tr: 'Güneş Gözlükleri', fa: 'عینک آفتابی', ps: 'د لمر عینکې', ru: 'Солнцезащитные очки', el: 'Γυαλιά ηλίου', ar: 'نظارات شمسية' },
        watches: { en: 'Watches', tr: 'Saatler', fa: 'ساعت‌ها', ps: 'ساعتونه', ru: 'Часы', el: 'Ρολόγια', ar: 'ساعات' },
        scarves: { en: 'Scarves', tr: 'Atkılar', fa: 'شال‌ها', ps: 'شالونه', ru: 'Шарфы', el: 'Κασκόλ', ar: 'أوشحة' },
    },
};

export const getCategoryKey = (rawCategory) => {
    if (!rawCategory) return '';
    // Backend should store a key string (e.g. "men"). Keep it simple.
    if (typeof rawCategory === 'string') return rawCategory;
    return '';
};

export const getCategoryLabel = (categoryKey, selectedLanguage) => {
    const labels = CATEGORY_I18N[categoryKey];
    if (!labels) return categoryKey || '';
    return labels[selectedLanguage] || labels.en || categoryKey;
};

export const getSubcategoryKey = (_categoryKey, rawSubcategory) => {
    if (!rawSubcategory) return '';
    if (typeof rawSubcategory === 'string') return rawSubcategory;
    return '';
};

export const getSubcategoryLabel = (categoryKey, subcategoryKey, selectedLanguage) => {
    const labels = SUBCATEGORY_I18N[categoryKey]?.[subcategoryKey];
    if (!labels) return subcategoryKey || '';
    return labels[selectedLanguage] || labels.en || subcategoryKey;
};

// Fallback when you only have a subcategory key (no parent category)
export const getSubcategoryLabelByKey = (subcategoryKey, selectedLanguage) => {
    if (!subcategoryKey) return '';
    for (const catKey of Object.keys(SUBCATEGORY_I18N)) {
        const labels = SUBCATEGORY_I18N[catKey]?.[subcategoryKey];
        if (labels) return labels[selectedLanguage] || labels.en || subcategoryKey;
    }
    return subcategoryKey;
};
